<template>
  <div v-if="$store.state.cartPrize.cart_prize_list.length" class="shadow" style="z-index:13000;width:20px;height:20px;border-radius:10px;position:absolute;top:-7px;right:0px;line-height:20px;text-align:center;color:#ffffff;font-size:12px;font-weight:500;" :style="{backgroundColor: getCssColor('primary_bt')}">
    {{$store.state.cartPrize.cart_prize_list.length}}
  </div>
</template>

<script>
import colors from '@/mixins/colors'
export default {
  name: 'PrizesBullet',
  mixins: [colors],
}
</script>